import { render, staticRenderFns } from "./InconsistenciesReport.vue?vue&type=template&id=a08dec12&scoped=true"
import script from "./InconsistenciesReport.vue?vue&type=script&lang=js"
export * from "./InconsistenciesReport.vue?vue&type=script&lang=js"
import style0 from "./InconsistenciesReport.vue?vue&type=style&index=0&id=a08dec12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08dec12",
  null
  
)

export default component.exports